import { faTag } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import * as seed from 'seedrandom';
import { Text } from '../Text';
import { StyledBadge } from './styles';

export type TColors =
  | 'red'
  | 'pink'
  | 'grape'
  | 'violet'
  | 'indigo'
  | 'blue'
  | 'cyan'
  | 'teal'
  | 'green'
  | 'lime'
  | 'yellow'
  | 'orange'
  | 'lavender'
  | 'mauve'
  | 'rose';

export const colors = [
  `red`,
  `pink`,
  `grape`,
  `violet`,
  `indigo`,
  `blue`,
  `cyan`,
  `teal`,
  `green`,
  `lime`,
  `yellow`,
  `orange`,
  `lavender`,
  `mauve`,
  `rose`,
];

interface IBadge {
  className?: string;
  children?: string | React.ReactElement;
  color?: TColors;
  randomColor?: boolean;
  leftSection?: React.ReactElement;
  rightSection?: React.ReactElement;
  large?: boolean;
  xlarge?: boolean;
  noHover?: boolean;
  stretch?: boolean;
  selected?: boolean;
  rounded?: boolean;
}

export const Badge = ({
  className,
  children,
  color = `grape`,
  randomColor,
  large = false,
  xlarge = false,
  noHover = false,
  leftSection = <FontAwesomeIcon icon={faTag} />,
  rightSection = <></>,
  stretch = false,
  selected = false,
  rounded = false,
}: IBadge) => {
  const randNum = Math.abs(seed(children).int32()) % 12;
  const oneToTwelveRand = colors[randNum];
  const selectedColor = randomColor ? oneToTwelveRand : color;
  const clonedLeftSection = React.cloneElement(leftSection, {
    className: `badge__left-icon`,
  });
  const clonedRightSection = React.cloneElement(rightSection, {
    className: `badge__right-icon`,
  });

  return (
    <StyledBadge
      className={className}
      color={selectedColor}
      large={large}
      xlarge={xlarge}
      noHover={noHover}
      stretch={stretch}
      selected={selected}
      rounded={rounded}
    >
      {clonedLeftSection}
      {children && (
        <Text
          noRhythem
          // eslint-disable-next-line no-nested-ternary
          type={xlarge ? `body1` : large ? `caption1` : `caption2`}
          tag="span"
          className="badge__text"
        >
          {children}
        </Text>
      )}
      {clonedRightSection}
    </StyledBadge>
  );
};
